/**
 * Voiceflow support chat widget.
 * Loaded only on support-portal pages (gated in theme.liquid), with an
 * internal path guard so the asset is self-protecting if referenced elsewhere.
 */
(function (d, t) {
  if (!window.location.pathname.includes('support-portal')) return;

  const PROJECT_ID = '6804a3ae3a517d28ef9f8d15';
  const AUTO_OPEN_MIN_WIDTH = 767;
  const AUTO_OPEN_DELAY_MS = 1000;

  const v = d.createElement(t);
  const s = d.getElementsByTagName(t)[0];

  v.onload = function () {
    window.voiceflow.chat
      .load({
        verify: { projectID: PROJECT_ID },
        url: 'https://general-runtime.voiceflow.com',
        versionID: 'production',
        voice: { url: 'https://runtime-api.voiceflow.com' },
      })
      .then(() => {
        if (window.innerWidth > AUTO_OPEN_MIN_WIDTH) {
          setTimeout(() => window.voiceflow.chat.open(), AUTO_OPEN_DELAY_MS);
        }
      });
  };

  v.src = 'https://cdn.voiceflow.com/widget-next/bundle.mjs';
  v.type = 'text/javascript';
  s.parentNode.insertBefore(v, s);
})(document, 'script');